import './bootstrap';
import '../css/app.css';

import {createApp, DefineComponent, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy';
import {i18n} from './i18n';

import.meta.glob('../images/**');
const appName = import.meta.env.VITE_APP_NAME || 'ImagineY';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),

    setup({el, App, props, plugin}) {
        createApp({
            render: () => h(App, props),
        })
            .use(ZiggyVue)
            .use(i18n)
            .use(plugin)
            .mount(el);
    },
    progress: {
        color: '#4B5563'
    },
}).catch(error => console.error(error));
